import { BTC_NETWORK_ID } from '@/constants'
import { useMultiWallet } from '@/context/multi-wallet.provider'

export const useWallet = () => {
  return useMultiWallet()
}

export const useBTCWallet = () => {
  const { wallets } = useWallet()
  return wallets[BTC_NETWORK_ID]
}
